import { Component } from '../core/Component';
import { Vector2 } from '../core/Vector2';

/**
 * Movement component for handling movement properties
 * Pure data component - no behavior/logic
 */
export class MovementComponent extends Component {
  public velocity: Vector2;
  public acceleration: Vector2;
  public maxSpeed: number;
  public drag: number;

  constructor(
    maxSpeed: number = 300,
    drag: number = 0.98,
    velocity: Vector2 = new Vector2(0, 0),
    acceleration: Vector2 = new Vector2(0, 0)
  ) {
    super();
    this.maxSpeed = maxSpeed;
    this.drag = drag;
    this.velocity = velocity;
    this.acceleration = acceleration;
  }

  public clone(): MovementComponent {
    return new MovementComponent(
      this.maxSpeed,
      this.drag,
      this.velocity.clone(),
      this.acceleration.clone()
    );
  }
}
